import {Badge} from "@mantine/core";
import {
    Price,
    RecurringOption
} from "../types.ts";

export const PriceRecurringOptionBadge = ({record}: { record: Price }) => {
    let color = '';
    if (record.recurringOption === RecurringOption.Yes) {
        color = 'blue';
    } else if (record.recurringOption === RecurringOption.No) {
        color = 'gray';
    }
    return <Badge color={color}>{record.recurringOption}</Badge>;
};
